import { useMemo } from 'react';

import { useDefaultVariants } from '@candu-ai/styleguide/application-variants';
import { BuiltInComponents } from 'craft/constants';
import { useMultiNodes } from 'craft/hooks/useMultiNodes';

export const useGetVariantRules = (nodeIds: string[]) => {
  const { data } = useDefaultVariants();

  const { type, variantId } = useMultiNodes(nodeIds, (node) => {
    if (node?.data.name === BuiltInComponents.Typography) {
      const { variant, variation } = node?.data?.custom?.custom || {};

      return {
        variantId: variation || variant || 'base',
      };
    }
    return {
      variantId: node?.data?.props?.variant ?? 'base',
    };
  });

  const { variants } = data || {};
  return useMemo(() => {
    if (!type) {
      return undefined;
    }
    return variants?.[type]?.[variantId];
  }, [type, variantId, variants]);
};
